import { createBooleanTagManager } from '../../utils/createBooleanTagManager';

export const developerTagManager = createBooleanTagManager({
  jsonQueryKey: 'from_developer',
  trueLabel: 'От застройщиков',
  falseLabel: 'От агентов и частных лиц',
  id: 'developer',
});
